/* KŌ fixes — the EU-Widerruf app writes inline "!important" styles onto its
   footer link, which no stylesheet can override. Re-neutralize them here so
   the link reads like every other footer menu item. */
(function () {
  var PROPS = [
    ['color', 'rgba(var(--color-foreground), 0.75)'],
    ['background-color', 'transparent'],
    ['background-image', 'none'],
    ['font-weight', '400'],
    ['font-size', '1.4rem'],
    ['line-height', 'inherit'],
    ['padding', '0'],
    ['margin', '0'],
    ['border-radius', '0'],
    ['vertical-align', 'baseline']
  ];

  function fix(a) {
    PROPS.forEach(function (p) { a.style.setProperty(p[0], p[1], 'important'); });
  }

  function run() {
    document.querySelectorAll('.footer a[href*="/apps/widerruf"]').forEach(function (a) {
      fix(a);
      var obs = new MutationObserver(function () {
        obs.disconnect();
        fix(a);
        obs.observe(a, { attributes: true, attributeFilter: ['style'] });
      });
      obs.observe(a, { attributes: true, attributeFilter: ['style'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
